import { render } from "./ConfirmationDialog.vue?vue&type=template&id=6c20a58d&scoped=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js"

import "@/styles/ConfirmationDialog.css?vue&type=style&index=0&id=6c20a58d&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c20a58d"]])

export default __exports__